import '@trukt/configs/tailwind/base.css';
import './App.css';

import { Suspense } from 'react';
import { Outlet } from '@tanstack/react-router';
import { Loading } from '@trukt/ui/Loading';
import { DefaultErrorBoundary } from '@trukt/ui/DefaultErrorBoundary';
import { SidebarContainer } from './shared/components/Sidebar/SidebarContainer';

const App = () => {
  return (
    <div className="page-content-container">
      <div>
        <SidebarContainer />
      </div>
      <div className="relative z-0 h-screen w-full overflow-hidden bg-bg-primary p-[10px] pl-0">
        <DefaultErrorBoundary>
          <Suspense fallback={<Loading fullscreen />}>
            <Outlet />
          </Suspense>
        </DefaultErrorBoundary>
      </div>
    </div>
  );
};

export default App;
